__turbopack_context__.v({
  "article": "BlogPostContent-module__wKJWca__article",
  "authorLink": "BlogPostContent-module__wKJWca__authorLink",
  "body": "BlogPostContent-module__wKJWca__body",
  "breadcrumbBar": "BlogPostContent-module__wKJWca__breadcrumbBar",
  "container": "BlogPostContent-module__wKJWca__container",
  "content": "BlogPostContent-module__wKJWca__content",
  "excerpt": "BlogPostContent-module__wKJWca__excerpt",
  "footer": "BlogPostContent-module__wKJWca__footer",
  "header": "BlogPostContent-module__wKJWca__header",
  "imageWrapper": "BlogPostContent-module__wKJWca__imageWrapper",
  "meta": "BlogPostContent-module__wKJWca__meta",
  "preferredSource": "BlogPostContent-module__wKJWca__preferredSource",
  "tag": "BlogPostContent-module__wKJWca__tag",
  "tags": "BlogPostContent-module__wKJWca__tags",
  "title": "BlogPostContent-module__wKJWca__title",
  "wrapper": "BlogPostContent-module__wKJWca__wrapper",
});
